import React from 'react';
import PropTypes from 'prop-types';
import VideosApprovedCount from './videos-approved-count';

import {
  SegmentName,
  SubheaderContainer,
  SegmentParticipants,
} from './styles';
import ApproveAllTestersButton from '../../../components/approve-all-testers-button';

const SegmentParticipant = (props) => {
  const {
    title, index, testSessionsWithSegment, projectId, refetchTestSessions, testSessionsOverflown, addApproveAll, isModerated, isUnmoderated,
  } = props;

  const participants = !testSessionsWithSegment?.testSessions ? 0 : testSessionsWithSegment.testSessions.length;
  const totalParticipants = testSessionsWithSegment?.participants;

  let text = '';

  if (isModerated) {
    text = `# Participants: ${participants} of ${totalParticipants} (${testSessionsOverflown} expired)`;
  } else {
    // ANY OTHER PROJECT TYPE
    text = `# Participants: ${participants} of ${totalParticipants}`;
  }
  return (
    <>
      <SegmentName>
        {`Audience Segment ${index + 1}: `}
        {title}
      </SegmentName>

      <SubheaderContainer>
        <SegmentParticipants>
          {text}
        </SegmentParticipants>
        {
          !isModerated && (
            <VideosApprovedCount testSessions={testSessionsWithSegment.testSessions} isUnmoderated={isUnmoderated} />
          )
        }

        {
          addApproveAll && (
            <ApproveAllTestersButton projectId={projectId} onRefetch={refetchTestSessions()} />
          )
        }
      </SubheaderContainer>
    </>
  );
};

SegmentParticipant.defaultProps = {
  projectId: '',
  refetchTestSessions: () => { },
  testSessionsOverflown: 0,
  isModerated: false,
  addApproveAll: false,
  isUnmoderated: false,
};

SegmentParticipant.propTypes = {
  isModerated: PropTypes.bool,
  isUnmoderated: PropTypes.bool,
  title: PropTypes.string.isRequired,
  index: PropTypes.number.isRequired,
  testSessionsWithSegment: PropTypes.shape({
    testSessions: PropTypes.arrayOf(PropTypes.shape()),
    participants: PropTypes.number,
  }).isRequired,
  projectId: PropTypes.string,
  refetchTestSessions: PropTypes.func,
  testSessionsOverflown: PropTypes.number,
  addApproveAll: PropTypes.bool,
};

export default SegmentParticipant;
